import { Navigate } from 'react-router-dom';

import { Route42Logo } from '../../../components/brand/Route42Logo';
import { useMachines } from '../api/useMachines';

export function MachineLandingPage() {
  const machines = useMachines();

  if (machines.isLoading) {
    return (
      <main className="r42-boot" aria-live="polite">
        <Route42Logo variant="mark" />
        <p>Loading your Route42 workspace…</p>
      </main>
    );
  }

  if (machines.isError) {
    return <Navigate to="/machines" replace />;
  }

  if (machines.data?.machines.length === 1) {
    return <Navigate to={`/machines/${machines.data.machines[0].id}`} replace />;
  }

  return <Navigate to="/machines" replace />;
}
